import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ScrollToTopButton from "../ScrollToTopButton";

const CyberSecurity = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    return (
        <div className="serviceDetails-mainsection">
            <ScrollToTopButton />
            <div className='container-fluid'>
                <div className='aboutus-bgsection'>
                    <div className='container'>
                        <h2 className='aboutus-header'>Service Details</h2>
                        <div>
                            <h3 className='pages-head'> <NavLink to={'/'} className="about-s">HOME</NavLink> <img className='' src='../assets/images/icon_rightabout.png' alt='arrow' /><NavLink to={'/Service'} className="about-s">Services</NavLink> <img className='' src='../assets/images/icon_rightabout.png' alt='arrow' />Cyber Security</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div className="serviceDetails-section2">
                <div className="container">
                    <div className="row">

                        <div className="col-md-8">

                            <div className="tab-content" id="v-pills-tabContent">
                                <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                                    <div className="serviceDetails-right">
                                        <h2 className="serviceDetails-head">IAM</h2>
                                        <p className="serviceDetails-text">4Sight Tech is a trusted Identity and Access Management (IAM) solutions provider, helping businesses secure digital identities, enforce access controls, and ensure compliance with industry standards. We specialize in enterprise-grade IAM solutions to protect critical data and streamline authentication processes.Our expertise includes Single Sign-On (SSO), Multi-Factor Authentication (MFA), Role-Based Access Control (RBAC), Privileged Access Management (PAM), and Identity Governance. By leveraging cloud IAM (AWS IAM, Azure AD, Okta), Zero Trust Security, and AI-driven threat detection, we help organizations prevent unauthorized access and security breaches.</p>
                                        {/* <p className="serviceDetails-text serviceDetails-text2">Over the last 35 Years we made an impact that is strong & we have long way to go.</p> */}
                                        <p className="serviceDetails-text">The best part of choosing our IAM consulting services is that we help businesses enhance security, reduce operational risks, and ensure regulatory compliance with seamless IAM implementations. Our team has worked with startups to Fortune 100+ companies, delivering scalable and intelligent IAM solutions tailored to business needs.On our journey to becoming one of the best IAM service providers, we continue to implement advanced authentication, access governance, and cybersecurity strategies to safeguard digital assets.</p>
                                        <img className="serviceDetails-imbg" src="../assets/images/services/cyber.jpg" alt="Cyber Security" />
                                        <h3 className="serviceDetails-head2">4Sight Tech Agency Values</h3>
                                        <p className="serviceDetails-text">At 4Sight Tech our culture comes to life through three core values:</p>
                                        <p className="serviceDetails-text serviceDetails-textwithim"><img src="../assets/images/services/icon.png" alt="fill" /> We seize opportunities to innovate and grow</p>
                                        <p className="serviceDetails-text serviceDetails-textwithim"><img src="../assets/images/services/icon.png" alt="fill" /> We are one firm with a shared sense of purpose</p>
                                        <p className="serviceDetails-text serviceDetails-textwithim"><img src="../assets/images/services/icon.png" alt="fill" /> We care about each other and the world around us</p>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <img className="serviceDetails-imgsec2" src="../assets/images/services/002.jpg" alt="sec" />
                                            </div>
                                            <div className="col-md-6">
                                                <img className="serviceDetails-imgsec2" src="../assets/images/services/001.jpg" alt="sec" />
                                            </div>
                                        </div>
                                        <p className="serviceDetails-text">We guide our clients through difficult issues, bringing our insight and judgment to each situa- tion. Our innovative approaches create original solutions to our clients’ most complex domes-tic & multi jurisdictional deals and disputes.</p>
                                        <p className="serviceDetails-text serviceDetails-text3">By thinkingn behalf of our clients every day, we anticipate what they want, provide what they need  & build lasting relationships.These are the concept that shape our distinctive culture & differentiate us from others.</p>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="serviceDetails-imgsection3left">
                                                    <div className="serviceDetails-imgsection31">
                                                        <div className="serviceDetails-imgsection31im">
                                                            <img className="serviceDetails-imgsection31im2" src="../assets/images/services/434343.png" alt="icon" />
                                                        </div>
                                                        <div className="rightsection">
                                                            <h3 className="rightsectionhead">Certified Experts</h3>
                                                            <p className="rightsectiontxt">We have amazing security
                                                                experts to save data</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="serviceDetails-imgsection3left">
                                                    <div className="serviceDetails-imgsection31">
                                                        <div className="serviceDetails-imgsection31im">
                                                            <img className="serviceDetails-imgsection31im2 serviceDetails-imgsection31im22" src="../assets/images/services/4343222.png" alt="icon" />
                                                        </div>
                                                        <div className="rightsection">
                                                            <h3 className="rightsectionhead">Quick Response</h3>
                                                            <p className="rightsectiontxt">Responding quickly is our
                                                                priority in dealing clients</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img className="serviceDetails-imgsec3" src="../assets/images/services/12121.jpg" alt="sec" />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                               

                            </div>

                        </div>
                        <div className="col-md-4">
                            <div className="serviceDetails-left">
                                <h3 className="serviceDetails-leftHead">Cyber Security</h3>
                                <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                    <button className="nav-link custm-bt active" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home" aria-selected="true">IAM<span><img src="../assets/images/icons/Icon_arrow_rightblack.png" alt="arrow" /></span></button>
                                    
                                </div>
                            </div>
                            <div className="call-section">
                                <div className="call-sectionbg">
                                    <div className="call-section2">
                                        <img className="call-section2im" src="../assets/images/services/Phone.png" alt="call" />
                                        <div>
                                            <p className="call-section2-txt">Have Any Questions?</p>
                                            <p className="call-section2-txt2">+1 945-419-8003</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="service-formsection">
                                <h3 className="service-formsectionhead">Send Us mail</h3>
                                <p className="service-formsectiontxt">4Sight Tech offers a range of Technology services
                                    for all firms all over the industry
                                </p>
                                <form>
                                    <div className="serviceform-bg">
                                        <input
                                            type="text"
                                            placeholder="Name*"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                            className="serviceform-bginp"
                                        />
                                        <img className="icons" src="../assets/images/services/Icon_user.png" alt="icon" />
                                    </div>
                                    <div className="serviceform-bg">
                                        <input
                                            type="email"
                                            placeholder="Email Address*"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            className="serviceform-bginp"
                                        />
                                        <img className="icons" src="../assets/images/services/Icon_mail6.png" alt="icon" />
                                    </div>
                                    <div className="serviceform-bg serviceform-bg2">
                                        <textarea
                                            placeholder="Text Here"
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            rows={5}
                                            className="serviceform-bginp serviceform-bginp3"
                                        />
                                    </div>
                                    <button className="serviceform-bt">Get Appointment</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default CyberSecurity;